import { isChannel } from "utils";
import api from "../../_config/http";
import { getChoosenFlight, getPricing } from "../../_services/airfare.service";

export function changeLocationsHotelAction(location) {
  return {
    type: "SEARCH_LOCATION_HOTEL",
    payload: {
      locationSearchHotel: location,
    },
  };
}

export function changeDatesHotelAction(dates) {
  const date = dates[0];

  var diffDays = 0;

  if (date?.startDate && date?.endDate) {
    var timeDiff = Math.abs(
      date?.startDate.getTime() - date?.endDate.getTime(),
    );
    diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
  }

  const datesFormat = {
    startDate: date?.startDate,
    endDate: date?.endDate,
    days: diffDays,
  };

  return {
    type: "SEARCH_DATES_HOTEL",
    payload: {
      datesSearchHotel: datesFormat,
    },
  };
}

export function changeGuestsAction(guests) {
  return {
    type: "SEARCH_GUESTS_HOTEL",
    payload: {
      guestsSearchHotel: guests,
    },
  };
}

export const changeOfferHotelAction = (data) => {
  return {
    type: "SEARCH_OFFER_HOTEL",
    payload: {
      offersHotel: data,
    },
  };
};

export const changeSelectedHotelAction = (data) => {
  return {
    type: "SEARCH_SELECTED_HOTEL",
    payload: {
      hotel: data,
    },
  };
};

export const changeSelectedRoomHotelAction = (data) => {
  return {
    type: "SEARCH_SELECTED_ROOM_HOTEL",
    payload: {
      room: data,
    },
  };
};

export const setTravellersHotelAction = (data) => {
  return {
    type: "SET_TRAVELLERS_HOTEL",
    payload: {
      travellers: data,
    },
  };
};

export const setHotelsListAction = (data) => {
  return {
    type: "SET_HOTELS_LIST",
    payload: {
      hotelsList: data,
    },
  };
};

export const clearSearch = () => {
  return {
    type: "CLEAR_SEARCH",
  };
};

export async function sha256Hex(input) {
  const data = new TextEncoder().encode(input);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}

export const checkoutHotelAction = async (props) => {
  const {
    customerId,
    hotel,
    room,
    cardSelected,
    totalPayment,
    installmentSelected,
    travellers,
    offersHotel,
    userDocument,
  } = props;

  const formatTravellers = travellers.map((item) => {
    const [day, month, year] = item.birthDate.split("/");
    const birthDate = year + "-" + month + "-" + day;

    return {
      firstName: item.firstName,
      middleName: "",
      lastName: item.lastName,
      birthDate: birthDate,
      gender: "male",
      documents: [
        {
          number: userDocument || process.env.REACT_APP_DEFAULT_TRAVELLER_DOCUMENT,
          documentType: "cpf",
        },
      ],
    };
  });

  hotel["rooms"] = [room];

  const checkout = {
    customerId,
    payment_type: offersHotel,
    fromChannel: localStorage.getItem("channel") || "safra",
    travellers: formatTravellers,
    hotel: {
      hotels: [hotel],
    },
  };

  const data = JSON.stringify(checkout);

  if (!isChannel("genial") && !isChannel("safra") && !isChannel("encantech-shop")) {
    // monta o pagamento conforme o tipo escolhido: pontos OU cartao
    // (antes enviava sempre os dois, e o pedido 100% em pontos chegava no
    // backend com um cartao "fantasma" de valor cheio e sem gateway_card_key)
    checkout.payment = (offersHotel || "points") === "points"
      ? [
          {
            type: "points",
            amount: totalPayment.points,
          },
        ]
      : [
          {
            type: "CREDIT",
            gateway_card_key: cardSelected?.gateway_card_key,
            amount: totalPayment.cash,
            installments: installmentSelected,
            save: false,
          },
        ];

    const data = JSON.stringify(checkout);

    return api.post("/hotels/order", data);
  } else {
    const salt = "z{*'";
    const hash = await sha256Hex(data + salt);
    localStorage.setItem("order_data", hash);
    return { data, hash };
  }
};

export const setTravellersAirfareAction = (data) => {
  return {
    type: "SET_TRAVELLERS_AIRFARE",
    payload: {
      travellers: data,
    },
  };
};

export const checkoutAirfareAction = async (props) => {
  const {
    customerId,
    offersAirfare,
    chooseId,
  } = props;

  let chosenData = null;
  let pricingData = null;

  if (chooseId) {
    const chosenResponse = await getChoosenFlight(chooseId);
    if (chosenResponse.status) {
      chosenData = chosenResponse.data?.data ?? chosenResponse.data;
    }

    try {
      const pricingResponse = await getPricing(chooseId);
      if (pricingResponse.status) {
        pricingData = pricingResponse.data?.data ?? pricingResponse.data;
      }
    } catch (e) {
      console.error(e);
    }
  }

  const checkoutData = {
    "customerId": customerId,
    "payment_type": offersAirfare || "points",
    "fromChannel": localStorage.getItem("channel") || "safra",
  };

  const envisionCheckoutPayload = {
    ...checkoutData,
    "choose_id": chooseId,
    "choosenFlight": chosenData,
    "pricing": pricingData,
  };

  const data = JSON.stringify(envisionCheckoutPayload);
  const salt = "z{*'";
  const hash = await sha256Hex(data + salt);
  localStorage.setItem("order_data", hash);

  return { data, hash };
};
